import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

const headers = {
    ...CommonVariables.API_HEADER,
    User: "MHL Sales Admin"
};

// ✅ Wrapper function for all GET calls
const fetchSalesData = async (url) => {
    return await trackPromise(
        axios.get(url, { headers })
    ).then(response => response)
     .catch(error => {
        return { data: { message: "Unauthorized" } }; // ✅ return same JSON structure always
     });
};

export const GetAccountDetails = async (clientCode) => {
    return fetchSalesData(
        CommonVariables.API_DOMAIN + `MHLSales/GetAccountDetailByClientCode?clientCode=${clientCode}`
    );
};

export const GetBarChartTestDetails = async (clientCode) => {
    return fetchSalesData(
        CommonVariables.API_DOMAIN + `MHLSales/GetBarChartTestDetails?clientCode=${clientCode}`
    );
};

export const InvoiceDetailList = async (clientCode) => {
    return fetchSalesData(
        CommonVariables.API_DOMAIN + `MHLSales/InvoiceDetailList?clientCode=${clientCode}`
    );
};

export const GetTestAndRevenueDetails = async (clientCode, month) => {
    return fetchSalesData(
        CommonVariables.API_DOMAIN + `MHLSales/GetTestAndRevenueDetails?clientCode=${clientCode}&month=${month}`
    );
};

export const GetRA_TransactionCard = async (clientCode) => {
    return fetchSalesData(
        CommonVariables.API_DOMAIN + `MHLSales/GetRA_TransactionCard?clientCode=${clientCode}`
    );
};

export const VisitSummary = async (clientCode) => {
    return fetchSalesData(
        CommonVariables.API_DOMAIN + `MHLSales/VisitSummary?clientCode=${clientCode}`
    );
};

export const GetBarChartVisitDetails = async (clientCode) => {
    return fetchSalesData(
        CommonVariables.API_DOMAIN + `MHLSales/GetBarChartVisitDetails?clientCode=${clientCode}`
    );
};
